'use client';

import { Flex, Skeleton, SkeletonText, Box, Drawer } from '@skin-seoul/design-system';
import React from 'react';

/**
 * Skeleton loading state for the Shopping Bag drawer
 * This component mimics the structure of CartWithItemView but with loading placeholders
 */
export const ShoppingBagSkeleton = () => {
  const renderSkeletonProductItems = () => {
    return Array(3)
      .fill(0)
      .map((_, index) => (
        <React.Fragment key={index}>
          <Flex padding="16px" width="100%" flexDirection="column" gap={3}>
            <Flex width="100%" gap={3}>
              <Skeleton height="80px" width="80px" borderRadius="8px" />
              <Flex flexDirection="column" justifyContent="space-between" flex={1} gap={2}>
                <SkeletonText noOfLines={1} width="70%" />
                <SkeletonText noOfLines={1} width="40%" />
                <Flex justifyContent="space-between" alignItems="center" width="100%">
                  <Skeleton height={4} width="80px" />
                  <Skeleton height={4} width="60px" />
                </Flex>
              </Flex>
            </Flex>
          </Flex>
          {index < 2 && <Flex borderBottom="1px solid" width="100%" borderColor="neutral.10" />}
        </React.Fragment>
      ));
  };

  return (
    <>
      <Drawer.Header
        alignItems="center"
        display="flex"
        height="72px"
        flexDirection="row"
        justifyContent="space-between"
        padding="10px"
        width="100%"
        paddingRight="20px"
      />

      <Drawer.Body padding="0" width="100%" overflowX="auto" paddingX="8px">
        <Flex flexDirection="column" height="100%" width="100%">
          {renderSkeletonProductItems()}
        </Flex>
      </Drawer.Body>

      <Flex
        backgroundColor="neutral.30"
        flexDirection="column"
        gap={5}
        height="fit-content"
        padding="20px"
        width="100%"
      >
        <Flex position="relative" flexDirection="column" width="100%" gap={5}>
          {/* Free Shipping Progress Skeleton */}
          <Box width="100%" padding="16px" borderRadius="8px" backgroundColor="white">
            <SkeletonText noOfLines={1} width="60%" />
          </Box>

          {/* Order Summary Skeleton */}
          <Box width="100%" padding="16px" borderRadius="8px" backgroundColor="white">
            <Flex justifyContent="space-between" marginBottom={2}>
              <SkeletonText noOfLines={1} width="30%" />
              <SkeletonText noOfLines={1} width="20%" />
            </Flex>
            <Flex justifyContent="space-between" marginTop={2}>
              <SkeletonText noOfLines={1} width="30%" />
              <SkeletonText noOfLines={1} width="20%" />
            </Flex>
          </Box>
        </Flex>

        {/* Checkout Button Skeleton */}
        <Skeleton height="48px" width="100%" borderRadius="8px" />
      </Flex>
    </>
  );
};

export default ShoppingBagSkeleton;
